import { Typography } from "@mui/material";

import { useHasHireJobs } from "../../api/queries/useGetHireJobs";

import NoJobPostedPage from "./NoJobPostedPage";
import JobsOverviewPage from "./JobsOverviewPage";

const GoHirePage = () => {
  const { hasHireJobs, isLoading } = useHasHireJobs();
  if (isLoading) return <Typography>Loading...</Typography>;
  if (hasHireJobs) return <JobsOverviewPage />;
  return <NoJobPostedPage />;
};

export default GoHirePage;
